import { Theme, useMediaQuery } from "@mui/material";
import { Fragment, useCallback, useContext } from "react";
import { TextField, DatagridConfigurable, List, SearchInput, useListContext, TopToolbar, FilterButton, SortButton, useGetResourceLabel, TextInput } from "react-admin";
import MobileGrid from "./MobileGrid";
import CoreCreateButton from "../../../shared/components/core/CoreCreateButton";
import { laboratoryRegistryExporter } from "../../../shared/utilities/adminExporter";
import SacopExportButton from "../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <CoreCreateButton permission="BACKOFFICE_LABORATORY_REGISTRY_C" />
        <SortButton fields={['oi']} />
        <FilterButton />
        <SacopExportButton exporter={laboratoryRegistryExporter} />
    </TopToolbar>
);

const laboratoryRegistryFilters = [
    <SearchInput source="q" alwaysOn />,

    <TextInput source="outsourcedAnalytes" />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    return (
        <Fragment>
            {(!isXSmall ? (
                <MobileGrid  {...listContext} />
            ) : (
                <DatagridConfigurable rowClick="edit" >
                    <TextField source="operationRegistry.dus" />
                </DatagridConfigurable>)
            )
            }
        </Fragment>
    );
}
export default function LaboratoryRegistryList() {
    const getResourceLabel = useGetResourceLabel();

    return (<List
        sort={{ field: 'oi', order: 'DESC' }}
        perPage={25}
        filters={laboratoryRegistryFilters}
        actions={<ListActions />}
        exporter={laboratoryRegistryExporter}
        title="resources.laboratory_registry.title"
    >
        <TabbedDatagrid />
    </List>);
}
